import React from 'react';
import { Hand, Sparkles, Heart } from 'lucide-react';
import { features } from '../data/mock';

export const FuzzFeature = () => {
  const feature = features[0];
  
  return (
    <section id="features" className="py-24 bg-gradient-to-br from-teal-50 to-emerald-50">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-teal-600 font-bold text-sm uppercase tracking-wider bg-teal-100 px-4 py-2 rounded-full">
                Social Proximity
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              {feature.title}
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {feature.description}
            </p>

            {/* Highlights */}
            <div className="space-y-4 pt-4">
              {feature.highlights.map((highlight, index) => {
                const icons = [Sparkles, Heart, Hand];
                const Icon = icons[index];
                return (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon className="h-5 w-5 text-teal-600" />
                    </div>
                    <span className="text-gray-700 text-lg font-medium">{highlight}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative z-10">
              <img 
                src="https://customer-assets.emergentagent.com/job_8f3822bc-92b7-49eb-9b5e-cbe543e4f048/artifacts/a9bs4ttt_Screenshot%202026-02-19%20at%2011.35.52%E2%80%AFAM.png"
                alt="Fuzz Wave Feature"
                className="rounded-3xl shadow-2xl w-full max-w-md mx-auto transform hover:scale-105 transition-transform duration-300"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal-200 rounded-full opacity-50 blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-emerald-200 rounded-full opacity-50 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
